import { createContext, useEffect, useReducer,  useState, useMemo } from "react";

// contex to render the updated data without refresh
// which means all components now have an access to the topic context
export const OrdersContext = createContext();

const initialState = {
  order: [],
  paymentMethod: 'online',
  name: '',
  email: '',
  lastOrderId: null,
};
export const orderReducer = (state, action) => {
  switch (action.type) {
    case "SET_ORDER":
      return {
        order: action.payload,
      };
    case "SET_LAST_ORDER_ID":
      return {
        ...state,
        lastOrderId: action.payload || null,
      };
    case 'UPDATE_ORDER_NOTES':
      return {
        ...state, order: action.payload
      };
    case "SET_PAYMENT_METHOD":
      return {
        ...state,
        paymentMethod: action.payload === 'inPerson' ? 'inPerson' : 'online',
      };
    case "CLEAR_ORDER":
      return {
        ...state,
        order: [],
        paymentMethod: action.payload,
        name: '',
        email: '',
      };
    case "ADD_ORDER": {
      // Check if the item already exists in the order
      const existingItemIndex = state.order.findIndex(item => item._id === action.payload._id && item.itemSize === action.payload.itemSize);
      
      if (existingItemIndex !== -1) {
        // If item exists, update the quantity
        const newOrder = [...state.order];
        newOrder[existingItemIndex] = {
          ...newOrder[existingItemIndex],
          itemQuantity: newOrder[existingItemIndex].itemQuantity + action.payload.itemQuantity
        };
        return { ...state, order: newOrder };
      } else {
        // If item does not exist, add it to the order
        return { ...state, order: [...state.order, action.payload] };
      }
    }
    case "REMOVE_ORDER":
      return {
        ...state,
        order: state.order.filter(item => item._id !== action.payload._id || item.itemSize !== action.payload.itemSize)
      };
    case 'UPDATE_ORDER_QUANTITY':
      return {
        ...state,
        order: action.payload
      };
    case "SET_USER_INFO":
      console.log('SET_USER_INFO');
      return {
        ...state,
        name: action.payload.name,
        email: action.payload.email,
      };
    case "UPDATE_ORDER":
      return {
        ...state,
        order: state.order.map((item) =>
          item._id === action.payload._id ? {...item, quantity: action.payload.quantity} : item
        ),
      };
    default:
      return state;
  }
};

export const OrdersContextProvider = ({ children }) => {
  const [isOrderBoxVisible, setIsOrderBoxVisible] = useState(false);
  const [state, dispatch] = useReducer(orderReducer, initialState, initial => {
    const localData = localStorage.getItem('orders');
    return localData ? JSON.parse(localData) : initial;
  });

  const totalQuantity = useMemo(() => state.order.reduce((acc, item) => acc + item.itemQuantity, 0), [state.order]);

  const setPaymentMethod = (method) => {
    dispatch({ type: "SET_PAYMENT_METHOD", payload: method });
  };

  const toggleOrderBox = () => {
    setIsOrderBoxVisible(prev => !prev);
  };

  useEffect(() => {
    localStorage.setItem('orders', JSON.stringify(state));
  }, [state]);

  return (
    <OrdersContext.Provider value={{
      ...state,
      dispatch,
      totalQuantity,
      isOrderBoxVisible,
      toggleOrderBox,
      setPaymentMethod,
    }}>
      {children}
    </OrdersContext.Provider>
  );
};
